import { Diagnostic } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Err, Ok } from "@siteimprove/alfa-result";
import { expectation } from "../act/expectation.js";
import { Question } from "../act/question.js";
const { isPerceivableForAll } = DOM;
function mediaTextAlternative(alt, label, device, kind) {
    return {
        1: alt.map((alt) => expectation(alt.isSome(), () => expectation(alt.some(isPerceivableForAll(device)), () => Outcomes.HasPerceivableAlternative(kind), () => Outcomes.HasNonPerceivableAlternative(kind)), () => Outcomes.HasNoAlternative(kind))),
        2: label.map((label) => expectation(label.isSome(), () => expectation(label.some(isPerceivableForAll(device)), () => Outcomes.HasPerceivableLabel(kind), () => Outcomes.HasNonPerceivableLabel(kind)), () => Outcomes.HasNoLabel(kind))),
    };
}
// keeping the next two functions separate because question should be split in two at some point.
export function audioTextAlternative(target, device) {
    const alt = Question.of("text-alternative", target, `Where is the text alternative of the \`<audio>\` element?`);
    const label = Question.of("label", target, `Where is the text that labels the \`<audio>\` element as an audio alternative?`);
    return mediaTextAlternative(alt, label, device, "<audio>");
}
export function videoTextAlternative(target, device) {
    const alt = Question.of("text-alternative", target, `Where is the text alternative of the \`<video>\` element?`);
    const label = Question.of("label", target, `Where is the text that labels the \`<video>\` element as a video alternative?`);
    return mediaTextAlternative(alt, label, device, "<video>");
}
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasPerceivableAlternative = (kind) => Ok.of(Diagnostic.of(`The \`${kind}\` element has a text alternative that is perceivable`));
    Outcomes.HasNonPerceivableAlternative = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` element has a text alternative that is not perceivable`));
    Outcomes.HasNoAlternative = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` element has no text alternative`));
    Outcomes.HasPerceivableLabel = (kind) => Ok.of(Diagnostic.of(`The \`${kind}\` element is labelled as an alternative for text and the label is perceivable`));
    Outcomes.HasNonPerceivableLabel = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` element is labelled as an alternative for text, but the label is not perceivable`));
    Outcomes.HasNoLabel = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` element is not labelled as an alternative for text`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=media-text-alternative.js.map